"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWorkingAccess = void 0;
var getWorkingAccess = exports.getWorkingAccess = function getWorkingAccess(appId, session, tenantId) {
  var _a;
  if (!session) return undefined;
  var accesses = (_a = session === null || session === void 0 ? void 0 : session.accesses) !== null && _a !== void 0 ? _a : [];
  if (tenantId) {
    var tenantedAccess = accesses.find(function (el) {
      var _a;
      return ((_a = el.tenant) === null || _a === void 0 ? void 0 : _a.id) === tenantId && el.apps;
    });
    if (tenantedAccess) {
      return tenantedAccess;
    }
    console.log('Any access was supplied for tenant %s', tenantId);
  }
  var sorted = accesses.sort(function (a, b) {
    if (a.tenant === undefined && b.tenant === undefined) {
      return 0;
    }
    if (a.tenant === undefined) {
      return -1;
    }
    if (b.tenant === undefined) {
      return 1;
    }
    return 0;
  });
  return sorted.filter(function (el) {
    return el.apps.find(function (app) {
      return app.id === appId;
    }) !== undefined;
  })[0];
};